import axios from "axios";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import LOGO from "../../assets/img/logo.png";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import Breadcrumbs from "../../common/breadcumb";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "./news.scss";
import { LangContext } from "../../context/LangContext";

function NewsDetail() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { category, slug } = useParams();

  let catUrl = category === "news-&-events" ? "news" : category;
  const API_URL = `${process.env.REACT_APP_URL}${catUrl}/detail/${slug}`;

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await axios.get(API_URL);
        setDetail(response.data.detail);
        // console.log("Detail data:", response.data.detail);
      } catch (err) {
        console.error("Error fetching news detail:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_URL]);

  const mainData = useMemo(() => {
    if (!detail) return null;
    return nep ? detail.np : detail.en;
  }, [detail, nep]);

  if (loading) return <Loading />;
  if (error || !mainData) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={mainData.title} />
      <div className="InsidePageContainer">
        <div className="faq-box">
          <div className="wrapper">
            <div className="detail-parent">
              {mainData.doc && (
                <div className="detail-img">
                  <img
                    data-bs-toggle="modal"
                    data-bs-target="#docModal"
                    src={mainData.doc}
                    alt={mainData.title}
                  />
                </div>
              )}

              {mainData.image && (
                <div className="detail-img">
                  <img
                    data-bs-toggle="modal"
                    data-bs-target="#imageModal"
                    src={mainData.image}
                    alt={mainData.title}
                  />
                </div>
              )}

              <div className="description">
                <div
                  dangerouslySetInnerHTML={{
                    __html: mainData.description || "",
                  }}
                />
              </div>
            </div>

            {/* Modal for doc */}
            {mainData.doc && (
              <div
                className="modal NewsDetails fade"
                id="docModal"
                tabIndex="-1"
                aria-labelledby="docModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body text-center">
                      <img
                        src={mainData.doc}
                        alt={mainData.title}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Modal for image */}
            {mainData.image && (
              <div
                className="modal NewsDetails fade"
                id="imageModal"
                tabIndex="-1"
                aria-labelledby="imageModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body text-center">
                      <img
                        src={mainData.image}
                        alt={mainData.title}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsDetail;
